<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">客户池</li>
    </ul>
    <ul class="c-list-search">
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="名称、统一社会信用代码、对接人"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="签约日期"
          end-placeholder="签约日期"
          value-format="YYYY-MM-DD"
          style="width: 100%"
          @change="
            (value) => {
              if (value)
                state.params.contract_time = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.contract_time;
          "
        />
      </li>
      <el-checkbox
        v-model="state.params.is_import"
        :false-value="0"
        label="显示全部"
        size="large"
        title="勾选显示已导入的客户"
        @change="onImportChange"
      />
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态"
          sortable="is_import"
          width="100"
          :formatter="
            (row) =>
              $statusFormat({
                Text: row.is_import == 0 ? '未导入' : '已导入',
                Color: row.is_import == 0 ? '#000' : '#080',
              })
          "
        />
        <el-table-column prop="customer_type" label="类型" width="120" />
        <el-table-column prop="name" label="名称" :min-width="160">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="名称"
              @click="$onCopy(row.name)"
            >
              {{ row.name }}
            </text>
          </template>
        </el-table-column>
        <el-table-column label="所属地区" min-width="220">
          <template #default="{ row }">
            <text>{{
              row.province +
              (row.city || "") +
              (row.district || "") +
              (row.address || "")
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          :formatter="$tab_TextFormat"
          width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column prop="contact_name" label="对接人姓名" width="120" />
        <el-table-column prop="contact_phone" label="联系方式" width="140" />
        <el-table-column prop="contract_time" label="签约时间" width="140" />
        <el-table-column
          label="操作"
          width="220"
          align="center"
          fixed="right"
          className="tabBtn"
          v-if="$judge_auth(['37', '38'])"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Download"
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              :disabled="row.is_import == 1"
              v-if="$judge_auth('37')"
            >
              导入
            </el-button>
            <el-button
              type="danger"
              link
              icon="Delete"
              @click="onDelete(row.id)"
              v-if="$judge_auth('38')"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showInfo"
        title="导入客户"
        @close="state.showInfo = false"
      >
        <c_CustomerPoolInfo
          @close="
            state.showInfo = false;
            onLoad();
          "
          :id="state.selectId"
        ></c_CustomerPoolInfo>
      </c_popup>
    </transition>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showBelonger"
        title="选择负责人"
        @close="state.showBelonger = false"
      >
        <c_AdminSelect
          @submit="
            (item) => {
              state.params.belonger_id = item.id;
              state.params.belonger = item.name + '/' + item.department_name;
              state.showBelonger = false;
            }
          "
          :id="state.model.belonger_id"
        ></c_AdminSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { customerpool_list, customerpool_delete } from "@/http/api";
import { admin_select } from "@/http/admin";
import { confirm_func } from "@/utils/qFormat";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
    is_import: 0,
  };
}
export default {
  props: {
    employee_id: Number,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      onLoadAdmin();
      state.params.employee_id = props.employee_id;
      onLoad();
    });

    //获取业务员
    const onLoadAdmin = () => {
      admin_select().then((res) => {
        if (res.status == 200) state.belongerData = res.data.data?.list;
      });
    };

    const onLoad = () => {
      delete state.tableData;
      customerpool_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    const onDateChange = (value) => {
      if (value) state.params.contract_time = value[0] + " - " + value[1];
      else delete state.params.contract_time;
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //删除
    const onDelete = (id) => {
      confirm_func(customerpool_delete, id, onLoad);
    };

    const onImportChange = (value) => {
      if (value) {
        delete state.params.is_import;
      } else {
        state.params.is_import = 0;
      }
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDelete,
      onDateChange,
      onImportChange,
    };
  },
};
</script>
<style scoped></style>
